import { BMEEmailTemplateName } from './tenant';

export enum EMAIL_STATUS {
  DONE = 'DONE',
  FAILED = 'FAILED',
}

export enum EMAIL_STATUS_COLOR {
  DONE = 'var(--success)',
  FAILED = 'var(--error)',
}

export const TEMPLATE_NAME_REMINDER: BMEEmailTemplateName[] = [];

export const TEMPLATE_NAME_WITHOUT_REMINDER: BMEEmailTemplateName[] = [];

export const TEMPLATE_NAME_DONOR: BMEEmailTemplateName[] = [
  BMEEmailTemplateName.ASK_DONOR_COMPLETE_FFQ,
  BMEEmailTemplateName.NOTICE_DONOR_FFQ_COMPLETE,
  BMEEmailTemplateName.REMIND_DONOR_SEND_OUT_KIT,
  BMEEmailTemplateName.REMIND_DONOR_SEND_OUT_KIT_TW0_WEEKS,
];

export const EMAIL_TEMPLATES: BMEEmailTemplateName[] = [
  // Donor
  BMEEmailTemplateName.REMIND_DONOR_SEND_OUT_KIT,
  BMEEmailTemplateName.ASK_DONOR_COMPLETE_FFQ,
  BMEEmailTemplateName.REMIND_DONOR_SEND_OUT_KIT_TW0_WEEKS,
  BMEEmailTemplateName.NOTICE_DONOR_FFQ_COMPLETE,
  // Donor

  BMEEmailTemplateName.SAMPLE_RECEIVED_AT_LAB_D2,
  BMEEmailTemplateName.ACTIVATION_INCOMPLETE_REMINDER_D31,
  BMEEmailTemplateName.REPORT_READY_D4,
  BMEEmailTemplateName.SAMPLE_RECEIVED_AT_LAB_B1,
  BMEEmailTemplateName.REPORT_READY_B2,
];
